function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { Plugin, PendingActions } from '@ckeditor/ckeditor5-core/dist/index.js';
import { ButtonView, MenuBarMenuListItemButtonView } from '@ckeditor/ckeditor5-ui/dist/index.js';
import { ElementReplacer, CKEditorError, createElement } from '@ckeditor/ckeditor5-utils/dist/index.js';
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
* @module source-editing/utils/formathtml
*/

/**
* A simple (and naive) HTML code formatter that returns a formatted HTML markup that can be easily
* parsed by human eyes. It beautifies the HTML code by adding new lines between elements that behave like block elements
* (https://developer.mozilla.org/en-US/docs/Web/HTML/Block-level_elements
* and a few more like `tr`, `td`, and similar ones) and inserting indents for nested content.
*
* WARNING: This function works only on a text that does not contain any indentations or new lines.
* Calling this function on the already formatted text will damage the formatting.
*
* @param input An HTML string to format.
*/

function formatHtml(input) {
  // A list of block-like elements around which the new lines should be inserted, and within which
  // the indentation of their children should be increased.
  // The list is partially based on https://developer.mozilla.org/en-US/docs/Web/HTML/Block-level_elements that contains
  // a full list of HTML block-level elements.
  // A void element is an element that cannot have any child - https://html.spec.whatwg.org/multipage/syntax.html#void-elements.
  // Note that <pre> element is not listed on this list to avoid breaking whitespace formatting.
  // Note that <br> element is not listed and handled separately so no additional white spaces are injected.
  var elementsToFormat = [{
    name: 'address',
    isVoid: false
  }, {
    name: 'article',
    isVoid: false
  }, {
    name: 'aside',
    isVoid: false
  }, {
    name: 'blockquote',
    isVoid: false
  }, {
    name: 'details',
    isVoid: false
  }, {
    name: 'dialog',
    isVoid: false
  }, {
    name: 'dd',
    isVoid: false
  }, {
    name: 'div',
    isVoid: false
  }, {
    name: 'dl',
    isVoid: false
  }, {
    name: 'dt',
    isVoid: false
  }, {
    name: 'fieldset',
    isVoid: false
  }, {
    name: 'figcaption',
    isVoid: false
  }, {
    name: 'figure',
    isVoid: false
  }, {
    name: 'footer',
    isVoid: false
  }, {
    name: 'form',
    isVoid: false
  }, {
    name: 'h1',
    isVoid: false
  }, {
    name: 'h2',
    isVoid: false
  }, {
    name: 'h3',
    isVoid: false
  }, {
    name: 'h4',
    isVoid: false
  }, {
    name: 'h5',
    isVoid: false
  }, {
    name: 'h6',
    isVoid: false
  }, {
    name: 'header',
    isVoid: false
  }, {
    name: 'hgroup',
    isVoid: false
  }, {
    name: 'hr',
    isVoid: true
  }, {
    name: 'li',
    isVoid: false
  }, {
    name: 'main',
    isVoid: false
  }, {
    name: 'nav',
    isVoid: false
  }, {
    name: 'ol',
    isVoid: false
  }, {
    name: 'p',
    isVoid: false
  }, {
    name: 'section',
    isVoid: false
  }, {
    name: 'table',
    isVoid: false
  }, {
    name: 'tbody',
    isVoid: false
  }, {
    name: 'td',
    isVoid: false
  }, {
    name: 'th',
    isVoid: false
  }, {
    name: 'thead',
    isVoid: false
  }, {
    name: 'tr',
    isVoid: false
  }, {
    name: 'ul',
    isVoid: false
  }];
  var elementNamesToFormat = elementsToFormat.map(function (element) {
    return element.name;
  }).join('|'); // It is not the fastest way to format the HTML markup but the performance should be good enough.

  var lines = input // Add new line before and after `<tag>` and `</tag>`.
  // It may separate individual elements with two new lines, but this will be fixed below.
  .replace(new RegExp("</?(".concat(elementNamesToFormat, ")( .*?)?>"), 'g'), '\n$&\n') // Keep `<br>`s at the end of line to avoid adding additional whitespaces before `<br>`.
  .replace(/<br[^>]*>/g, '$&\n') // Divide input string into lines, which start with either an opening tag, a closing tag, or just a text.
  .split('\n');
  var indentCount = 0;
  var isPreformattedLine = false;
  return lines.filter(function (line) {
    return line.length;
  }).map(function (line) {
    isPreformattedLine = isPreformattedBlockLine(line, isPreformattedLine);

    if (isNonVoidOpeningTag(line, elementsToFormat)) {
      return indentLine(line, indentCount++);
    }

    if (isClosingTag(line, elementsToFormat)) {
      return indentLine(line, --indentCount);
    }

    if (isPreformattedLine === 'middle' || isPreformattedLine === 'last') {
      return line;
    }

    return indentLine(line, indentCount);
  }).join('\n');
}
/**
 * Checks, if an argument is an opening tag of a non-void element to be formatted.
 *
 * @param line String to check.
 * @param elementsToFormat Elements to be formatted.
 */


function isNonVoidOpeningTag(line, elementsToFormat) {
  return elementsToFormat.some(function (element) {
    if (element.isVoid) {
      return false;
    }

    if (!new RegExp("<".concat(element.name, "( .*?)?>")).test(line)) {
      return false;
    }

    return true;
  });
}
/**
 * Checks, if an argument is a closing tag.
 *
 * @param line String to check.
 * @param elementsToFormat Elements to be formatted.
 */


function isClosingTag(line, elementsToFormat) {
  return elementsToFormat.some(function (element) {
    return new RegExp("</".concat(element.name, ">")).test(line);
  });
}
/**
 * Indents a line by a specified number of characters.
 *
 * @param line Line to indent.
 * @param indentCount Number of characters to use for indentation.
 * @param indentChar Indentation character(s). 4 spaces by default.
 */


function indentLine(line, indentCount) {
  var indentChar = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '    ';
  // More about Math.max() here in https://github.com/ckeditor/ckeditor5/issues/10698.
  return "".concat(indentChar.repeat(Math.max(0, indentCount))).concat(line);
}
/**
 * Checks whether a line belongs to a preformatted (`<pre>`) block.
 *
 * @param line Line to check.
 * @param isPreviousLinePreFormatted Information on whether the previous line was preformatted (and how).
 */


function isPreformattedBlockLine(line, isPreviousLinePreFormatted) {
  if (new RegExp('<pre( .*?)?>').test(line)) {
    return 'first';
  } else if (new RegExp('</pre>').test(line)) {
    return 'last';
  } else if (isPreviousLinePreFormatted === 'first' || isPreviousLinePreFormatted === 'middle') {
    return 'middle';
  } else {
    return false;
  }
}

var sourceEditingIcon = "<svg viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m12.5 0 5 4.5v15.003h-16V0h11zM3 1.5v3.25l-1.497 1-.003 8 1.5 1v3.254L7.685 18l-.001 1.504H17.5V8.002L16 9.428l-.004-4.22-4.222-3.692L3 1.5z\"/><path d=\"M4.06 6.64a.75.75 0 0 1 .958 1.15l-.085.07L2.29 9.75l2.646 1.89c.302.216.4.62.232.951l-.058.095a.75.75 0 0 1-.951.232l-.095-.058-3.5-2.5V9.14l3.496-2.5zm4.194 6.22a.75.75 0 0 1-.958-1.149l.085-.07 2.643-1.89-2.646-1.89a.75.75 0 0 1-.232-.952l.058-.095a.75.75 0 0 1 .95-.232l.096.058 3.5 2.5v1.22l-3.496 2.5zm7.644-.836 2.122 2.122-5.825 5.809-2.125-.005.003-2.116zm2.539-1.847 1.414 1.414a.5.5 0 0 1 0 .707l-1.06 1.06-2.122-2.12 1.061-1.061a.5.5 0 0 1 .707 0z\"/></svg>";
var COMMAND_FORCE_DISABLE_ID = 'SourceEditingMode';
/**
 * The source editing feature.
 *
 * It provides the possibility to view and edit the source of the document.
 *
 * For a detailed overview, check the {@glink features/source-editing source editing feature documentation} and the
 * {@glink api/source-editing package page}.
 */

var SourceEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(SourceEditing, _Plugin);

  var _super = _createSuper(SourceEditing);

  /**
  * @inheritDoc
  */
  function SourceEditing(editor) {
    var _this;

    _classCallCheck(this, SourceEditing);

    _this = _super.call(this, editor);
    _this._elementReplacer = void 0;
    _this._replacedRoots = void 0;
    _this._dataFromRoots = void 0;

    _this.set('isSourceEditingMode', false);

    _this._elementReplacer = new ElementReplacer();
    _this._replacedRoots = new Map();
    _this._dataFromRoots = new Map();
    editor.config.define('sourceEditing.allowCollaborationFeatures', false);
    return _this;
  }
  /**
  * @inheritDoc
  */


  _createClass(SourceEditing, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      this._checkCompatibility();

      var editor = this.editor;
      var t = editor.locale.t;
      editor.ui.componentFactory.add('sourceEditing', function () {
        var buttonView = _this2._createButton(ButtonView);

        buttonView.set({
          label: t('Source'),
          icon: sourceEditingIcon,
          tooltip: true,
          class: 'ck-source-editing-button'
        });
        return buttonView;
      });
      editor.ui.componentFactory.add('menuBar:sourceEditing', function () {
        var buttonView = _this2._createButton(MenuBarMenuListItemButtonView);

        buttonView.set({
          label: t('Show source'),
          role: 'menuitemcheckbox'
        });
        return buttonView;
      }); // Currently, the plugin handles the source editing mode by itself only for the classic editor. To use this plugin with other
      // integrations, listen to the `change:isSourceEditingMode` event and act accordingly.

      if (this._isAllowedToHandleSourceEditingMode()) {
        this.on('change:isSourceEditingMode', function (evt, name, isSourceEditingMode) {
          if (isSourceEditingMode) {
            _this2._hideVisibleDialog();

            _this2._showSourceEditing();

            _this2._disableCommands();
          } else {
            _this2._hideSourceEditing();

            _this2._enableCommands();
          }
        });
        this.on('change:isEnabled', function (evt, name, isEnabled) {
          return _this2._handleReadOnlyMode(!isEnabled);
        });
        this.listenTo(editor, 'change:isReadOnly', function (evt, name, isReadOnly) {
          return _this2._handleReadOnlyMode(isReadOnly);
        });
      } // Update the editor data while calling editor.getData() in the source editing mode.


      editor.data.on('get', function () {
        if (_this2.isSourceEditingMode) {
          _this2.updateEditorData();
        }
      }, {
        priority: 'high'
      });
    }
    /**
    * Updates the source data in all hidden editing roots.
    */

  }, {
    key: "updateEditorData",
    value: function updateEditorData() {
      var editor = this.editor;
      var data = {};

      var _iterator = _createForOfIteratorHelper(this._replacedRoots),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ref3 = _step.value;

          var _ref2 = _slicedToArray(_ref3, 2);

          var rootName = _ref2[0];
          var domSourceEditingElementWrapper = _ref2[1];

          var oldData = this._dataFromRoots.get(rootName);

          var newData = domSourceEditingElementWrapper.dataset.value; // Do not set the data unless some changes have been made in the meantime.
          // This prevents empty undo steps after switching to the normal editor.

          if (oldData !== newData) {
            data[rootName] = newData;

            this._dataFromRoots.set(rootName, newData);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (Object.keys(data).length) {
        editor.data.set(data, {
          batchType: {
            isUndoable: true
          },
          suppressErrorInCollaboration: true
        });
      }
    }
  }, {
    key: "_checkCompatibility",
    value: function _checkCompatibility() {
      var editor = this.editor;
      var allowCollaboration = editor.config.get('sourceEditing.allowCollaborationFeatures');

      if (!allowCollaboration && editor.plugins.has('RealTimeCollaborativeEditing')) {
        /**
        * Source editing feature is not fully compatible with real-time collaboration,
        * and using it may lead to data loss. Please read
        * {@glink features/source-editing#limitations-and-incompatibilities source editing feature guide} to learn more.
        *
        * If you understand the possible risk of data loss, you can enable the source editing
        * by setting the
        * {@link module:source-editing/sourceeditingconfig~SourceEditingConfig#allowCollaborationFeatures}
        * configuration flag to `true`.
        *
        * @error source-editing-incompatible-with-real-time-collaboration
        */
        throw new CKEditorError('source-editing-incompatible-with-real-time-collaboration', null);
      }

      var collaborationPluginNamesToWarn = ['CommentsEditing', 'TrackChangesEditing', 'RevisionHistory']; // Currently, the basic integration with Collaboration Features is to display a warning in the console.
      //
      // If `allowCollaboration` flag is set, do not show these warnings. If the flag is set, we assume that the integrator read
      // appropriate section of the guide so there's no use to spam the console with warnings.
      //

      if (!allowCollaboration && collaborationPluginNamesToWarn.some(function (pluginName) {
        return editor.plugins.has(pluginName);
      })) {
        console.warn('You initialized the editor with the source editing feature and at least one of the collaboration features. ' + 'Please be advised that the source editing feature may not work, and be careful when editing document source ' + 'that contains markers created by the collaboration features.');
      } // Restricted Editing integration can also lead to problems. Warn the user accordingly.


      if (editor.plugins.has('RestrictedEditingModeEditing')) {
        console.warn('You initialized the editor with the source editing feature and restricted editing feature. ' + 'Please be advised that the source editing feature may not work, and be careful when editing document source ' + 'that contains markers created by the restricted editing feature.');
      }
    }
    /**
    * Creates source editing wrappers that replace each editing root. Each wrapper contains the document source from the corresponding
    * root.
    *
    * The wrapper element contains a textarea and it solves the problem, that the textarea element cannot auto expand its height based on
    * the content it contains. The solution is to make the textarea more like a plain div element, which expands in height as much as it
    * needs to, in order to display the whole document source without scrolling. The wrapper element is a parent for the textarea and for
    * the pseudo-element `::after`, that replicates the look, content, and position of the textarea. The pseudo-element replica is hidden,
    * but it is styled to be an identical visual copy of the textarea with the same content. Then, the wrapper is a grid container and both
    * of its children (the textarea and the `::after` pseudo-element) are positioned within a CSS grid to occupy the same grid cell. The
    * content in the pseudo-element `::after` is set in CSS and it stretches the grid to the appropriate size based on the textarea value.
    * Since both children occupy the same grid cell, both have always the same height.
    */

  }, {
    key: "_showSourceEditing",
    value: function _showSourceEditing() {
      var _this3 = this;

      var editor = this.editor;
      var editingView = editor.editing.view;
      var model = editor.model;
      model.change(function (writer) {
        writer.setSelection(null);
        writer.removeSelectionAttribute(model.document.selection.getAttributeKeys());
      }); // It is not needed to iterate through all editing roots, as currently the plugin supports only the Classic Editor with a single
      // main root, but this code may help understand and use this feature in external integrations.

      var _iterator2 = _createForOfIteratorHelper(editingView.domRoots),
          _step2;

      try {
        var _loop = function _loop() {
          var _ref4 = _step2.value;
          _ref5 = _slicedToArray(_ref4, 2);
          var rootName = _ref5[0];
          var domRootElement = _ref5[1];
          var data = formatSource(editor.data.get({
            rootName: rootName
          }));
          var domSourceEditingElementTextarea = createElement(domRootElement.ownerDocument, 'textarea', {
            rows: '1',
            'aria-label': 'Source code editing area'
          });
          var domSourceEditingElementWrapper = createElement(domRootElement.ownerDocument, 'div', {
            class: 'ck-source-editing-area',
            'data-value': data
          }, [domSourceEditingElementTextarea]);
          domSourceEditingElementTextarea.value = data; // Setting a value to textarea moves the input cursor to the end. We want the selection at the beginning.

          domSourceEditingElementTextarea.setSelectionRange(0, 0); // Bind the textarea's value to the wrapper's `data-value` property. Each change of the textarea's value updates the
          // wrapper's `data-value` property.

          domSourceEditingElementTextarea.addEventListener('input', function () {
            domSourceEditingElementWrapper.dataset.value = domSourceEditingElementTextarea.value;
            editor.ui.update();
          });
          editingView.change(function (writer) {
            var viewRoot = editingView.document.getRoot(rootName);
            writer.addClass('ck-hidden', viewRoot);
          }); // Register the element so it becomes available for Alt+F10 and Esc navigation.

          editor.ui.setEditableElement('sourceEditing:' + rootName, domSourceEditingElementTextarea);

          _this3._replacedRoots.set(rootName, domSourceEditingElementWrapper);

          _this3._elementReplacer.replace(domRootElement, domSourceEditingElementWrapper);

          _this3._dataFromRoots.set(rootName, data);
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _ref5;

          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this._focusSourceEditing();
    }
    /**
    * Restores all hidden editing roots and sets the source data in them.
    */

  }, {
    key: "_hideSourceEditing",
    value: function _hideSourceEditing() {
      var _this4 = this;

      var editor = this.editor;
      var editingView = editor.editing.view;
      this.updateEditorData();
      editingView.change(function (writer) {
        var _iterator3 = _createForOfIteratorHelper(_this4._replacedRoots),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _ref8 = _step3.value;

            var _ref7 = _slicedToArray(_ref8, 1);

            var rootName = _ref7[0];
            writer.removeClass('ck-hidden', editingView.document.getRoot(rootName));
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      });

      this._elementReplacer.restore();

      this._replacedRoots.clear();

      this._dataFromRoots.clear();

      editingView.focus();
    }
    /**
    * Focuses the textarea containing document source from the first editing root.
    */

  }, {
    key: "_focusSourceEditing",
    value: function _focusSourceEditing() {
      var editor = this.editor;

      var _this$_replacedRoots$ = this._replacedRoots.values(),
          _this$_replacedRoots$2 = _slicedToArray(_this$_replacedRoots$, 1),
          domSourceEditingElementWrapper = _this$_replacedRoots$2[0];

      var textarea = domSourceEditingElementWrapper.querySelector('textarea'); // The FocusObserver was disabled by View.render() while the DOM root was getting hidden and the replacer
      // revealed the textarea. So it couldn't notice that the DOM root got blurred in the process.
      // Let's sync this state manually here because otherwise Renderer will attempt to render selection
      // in an invisible DOM root.

      editor.editing.view.document.isFocused = false;
      textarea.focus();
    }
    /**
    * Disables all commands.
    */

  }, {
    key: "_disableCommands",
    value: function _disableCommands() {
      var editor = this.editor;

      var _iterator4 = _createForOfIteratorHelper(editor.commands.commands()),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var command = _step4.value;
          command.forceDisabled(COMMAND_FORCE_DISABLE_ID);
        } // Comments archive UI plugin will be disabled manually too.

      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      if (editor.plugins.has('CommentsArchiveUI')) {
        editor.plugins.get('CommentsArchiveUI').forceDisabled(COMMAND_FORCE_DISABLE_ID);
      }
    }
    /**
    * Clears forced disable for all commands, that was previously set through {@link #_disableCommands}.
    */

  }, {
    key: "_enableCommands",
    value: function _enableCommands() {
      var editor = this.editor;

      var _iterator5 = _createForOfIteratorHelper(editor.commands.commands()),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var command = _step5.value;
          command.clearForceDisabled(COMMAND_FORCE_DISABLE_ID);
        } // Comments archive UI plugin will be enabled manually too.

      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      if (editor.plugins.has('CommentsArchiveUI')) {
        editor.plugins.get('CommentsArchiveUI').clearForceDisabled(COMMAND_FORCE_DISABLE_ID);
      }
    }
    /**
    * Adds or removes the `readonly` attribute from the textarea from all roots, if document source mode is active.
    *
    * @param isReadOnly Indicates whether all textarea elements should be read-only.
    */

  }, {
    key: "_handleReadOnlyMode",
    value: function _handleReadOnlyMode(isReadOnly) {
      if (!this.isSourceEditingMode) {
        return;
      }

      var _iterator6 = _createForOfIteratorHelper(this._replacedRoots),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _ref11 = _step6.value;

          var _ref10 = _slicedToArray(_ref11, 2);

          var domSourceEditingElementWrapper = _ref10[1];
          domSourceEditingElementWrapper.querySelector('textarea').readOnly = isReadOnly;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
    /**
    * Checks, if the plugin is allowed to handle the source editing mode by itself. Currently, the source editing mode is supported only
    * for the {@link module:editor-classic/classiceditor~ClassicEditor classic editor}.
    */

  }, {
    key: "_isAllowedToHandleSourceEditingMode",
    value: function _isAllowedToHandleSourceEditingMode() {
      var editor = this.editor;
      var editable = editor.ui.view.editable; // Checks, if the editor's editable belongs to the editor's DOM tree.

      return editable && !editable.hasExternalElement;
    }
    /**
    * If any {@link module:ui/dialog/dialogview~DialogView editor dialog} is currently visible, hide it.
    */

  }, {
    key: "_hideVisibleDialog",
    value: function _hideVisibleDialog() {
      if (this.editor.plugins.has('Dialog')) {
        var dialogPlugin = this.editor.plugins.get('Dialog');

        if (dialogPlugin.isOpen) {
          dialogPlugin.hide();
        }
      }
    }
  }, {
    key: "_createButton",
    value: function _createButton(ButtonClass) {
      var _this5 = this;

      var editor = this.editor;
      var buttonView = new ButtonClass(editor.locale);
      buttonView.set({
        withText: true,
        isToggleable: true
      });
      buttonView.bind('isOn').to(this, 'isSourceEditingMode'); // The button should be disabled if one of the following conditions is met:

      buttonView.bind('isEnabled').to(this, 'isEnabled', editor, 'isReadOnly', editor.plugins.get(PendingActions), 'hasAny', function (isEnabled, isEditorReadOnly, hasAnyPendingActions) {
        // (1) The plugin itself is disabled.
        if (!isEnabled) {
          return false;
        } // (2) The editor is in read-only mode.


        if (isEditorReadOnly) {
          return false;
        } // (3) Any pending action is scheduled. It may change the model, so modifying the document source should be prevented
        // until the model is finally set.


        if (hasAnyPendingActions) {
          return false;
        }

        return true;
      });
      this.listenTo(buttonView, 'execute', function () {
        _this5.isSourceEditingMode = !_this5.isSourceEditingMode;
      });
      return buttonView;
    }
  }], [{
    key: "pluginName",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return 'SourceEditing';
    }
    /**
    * @inheritDoc
    */

  }, {
    key: "requires",
    get: function get() {
      return [PendingActions];
    }
    /**
    * The element replacer instance used to replace the editing roots with the wrapper elements containing the document source.
    */

    /**
    * Maps all root names to wrapper elements containing the document source.
    */

    /**
    * Maps all root names to their document data.
    */

  }]);

  return SourceEditing;
}(Plugin);
/**
 * Formats the content for a better readability.
 *
 * For a non-HTML source the unchanged input string is returned.
 *
 * @param input Input string to check.
 */


function formatSource(input) {
  if (!isHtml(input)) {
    return input;
  }

  return formatHtml(input);
}
/**
 * Checks, if the document source is HTML. It is sufficient to just check the first character from the document data.
 *
 * @param input Input string to check.
 */


function isHtml(input) {
  return input.startsWith('<');
}

export { SourceEditing };